export interface MessageCheckerState {
    unreadCount: number;
    newUnreadSignal: number;
}

export const initialMessageCheckerState: MessageCheckerState = {
    unreadCount: 0,
    newUnreadSignal: 0,
};
